import liff from '@line/liff/dist/lib';
export const closeApp = () => liff.closeWindow();
